import { render, staticRenderFns } from "./Mnrcv.vue?vue&type=template&id=74523bbf"
import script from "./Mnrcv.vue?vue&type=script&lang=js"
export * from "./Mnrcv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74523bbf')) {
      api.createRecord('74523bbf', component.options)
    } else {
      api.reload('74523bbf', component.options)
    }
    module.hot.accept("./Mnrcv.vue?vue&type=template&id=74523bbf", function () {
      api.rerender('74523bbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/Mnrcv.vue"
export default component.exports